<template>
  <v-row class="text-center">
    <v-col cols="12">
      <v-card elevation="3">
        <v-card-text>
          <!-- <div class="font-weight-medium">ATTENDANCE SHEET</div> -->
          <div class="text--primary">
            <div>
              <a
                class="text-decoration-none font-weight-medium"
                target="_blank"
                href="https://docs.google.com/forms/d/e/1FAIpQLSfGAoTv0ITS8BoKAvk3aV01SeFKCLm9OlXgppD5le-3esjOjg/viewform"
                >FEEDBACK FORM</a
              >
            </div>
          </div>
          <br />

          <br />
          <div class="text--primary">
            <div>
              <a
                class="text-decoration-none font-weight-medium"
                target="_blank"
                href="https://docs.google.com/spreadsheets/d/1SGcM8omKr-fKq8I5oxwcr9i12LtApGAdPvgVPFDXQXo/edit?usp=sharing"
                >ATTENDANCE SHEET</a
              >
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {};
</script>

<style>
</style>